import { render, staticRenderFns } from "./CreateGuardian.vue?vue&type=template&id=00bb9c0a"
import script from "./CreateGuardian.vue?vue&type=script&lang=js"
export * from "./CreateGuardian.vue?vue&type=script&lang=js"
import style0 from "./CreateGuardian.vue?vue&type=style&index=0&id=00bb9c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports